var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.986,121.399l-4.361,1.364c0,0-0.546,3-2.182,3.545c-1.637,0.545-8.455-6.545-8.455-6.545l1.635-9.544l-2.998-4.093 h-13.363l-20.184-67.089l-18.272-7.91l-11.999,9.818v2.453l-2.73,3.546l-6.816-2.182l-4.089-7.908h-3.001L92.897,74.217 c0,0,1.09,12.545,2.181,15.274c1.09,2.725-5.455,7.634-5.455,7.634l-1.089,13.637l6.544,4.638l-12,21.546v18.544l-10.363-1.908 l27.272,84.546l1.365,5.181l7.364,3.002v6.544l5.425,3.39c0.396-0.283,0.773-0.59,1.119-0.936c7.09-7.09,3.545-26.824,3.545-26.824 l3.818-3.176l-1.909-5.998l8.183-7.365l2.454,2.729l14.999-8.729l0.273-6.002h5.455l4.091-5.179c0,0-2.456-12.272-1.364-12.546 c1.089-0.273,3.363-3.001,3.363-3.001l-4.727-4.909l4.727-3.545l4.274,7.636l3.271-0.545l0.273,5.454l3.546,1.364l3.001-6.818 l-4.639-3.001c0,0,2.185-1.908,4.639-5.181c2.455-3.273,8.453-5.455,8.453-5.455s1.909,2.454,2.728,3.274 c0.818,0.816,4.637,0,4.637,0l16.362-18.273h4.909c0,0,4.909-11.457,4.909-13.637C214.533,133.399,204.986,121.399,204.986,121.399 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.169,183.991 159.579,188.129 163.533,194.492 166.67,192.173 165.715,186.718  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.58,174.854l5.862,4.364c0,0,0-5.59,0.683-5.59s2.863-2.183,2.863-2.183l-4.228-3.034 C179.761,168.411,175.057,170.523,174.58,174.854z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaine);
export default __webpack_public_path__ + "static/media/maine.710702145f6422cde0a5faa92678165d.svg";
export { ForwardRef as ReactComponent };